<script setup lang="ts">
import {
  ComboboxRoot,
  useForwardPropsEmits,
  type ComboboxRootProps,
  type ComboboxRootEmits
} from 'reka-ui'
import { cn } from '@/lib/utils'
import type { ClassValue } from 'clsx'

interface Props extends ComboboxRootProps {
  class?: ClassValue
}

const props = defineProps<Props>()
const emits = defineEmits<ComboboxRootEmits>()

const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
  <ComboboxRoot
    v-bind="forwarded"
    :open="true"
    :model-value="''"
    :class="
      cn(
        'bg-popover text-popover-foreground flex h-full w-full flex-col overflow-hidden rounded-md',
        $attrs.class ?? ''
      )
    "
  >
    <slot />
  </ComboboxRoot>
</template>
